import request from '@/plugins/axios'

export function listApi(params) {
  // 分页获取
  return request({
    url: `/mark/twitter_accounts`,
    method: 'get',
    params
  })
}
export function addApi(data) {
  // 新增twitter账号标签
  return request({
    url: `/mark/twitter_accounts`,
    method: 'post',
    data
  })
}
export function batch_tagApi(twitter_account_id, ids) {
  // twitter账号多个标签
  return request({
    url: `/mark/twitter_accounts/${twitter_account_id}:batch_tag`,
    method: 'post',
    data: {
      ids: ids
    }
  })
}
export function detailApi(id) {
  // 获取指定twitter账号标签
  return request({
    url: `/mark/twitter_accounts/${id}`,
    method: 'get'
  })
}
export function delApi(id) {
  // 删除
  return request({
    url: `/mark/twitter_accounts/${id}`,
    method: 'delete'
  })
}
// 批量更新账号标签
export function batchTagApi(id, data) {
  // 删除
  return request({
    url: `/mark/twitter_accounts/${id}:batch_update_tag`,
    method: 'post',
    data
  })
}
